<!-- 营业执照输入框 -->
<!--
  1. 代理 inputAlign 属性
 -->
<template>
  <input
    v-bind="getBindValue"
  >
</template>

<script lang="ts" setup>
import { computed, useAttrs, nextTick } from 'vue'
import { businessLicenseInputProps } from './props'

/* data 数据 */
const props = defineProps(businessLicenseInputProps)
const attrs = useAttrs()
const emits = defineEmits(['update:modelValue'])
const getBindValue = computed(() => ({
  class: props.textAlign === 'left' ? 'text-left' : 'text-right',
  value: props.modelValue,
  oninput: async e => {
    const value = e.detail.value.toUpperCase().slice(0, props.maxLength)
    if (value === props.modelValue) {
      emits('update:modelValue', e.detail.value)
      await nextTick()
    }
    emits('update:modelValue', value)
  },
  ...attrs
}))


</script>